<template>
  <el-form ref="form" label-position="top">
    <h1 class="mb0">Experience</h1>

    <p class="quote mt1">
      “Praise be to the God and Father of our Lord Jesus Christ, the Father of compassion and the God of all
      comfort, who comforts us in all our troubles, so that we can comfort those in any trouble with the comfort
      we ourselves have received from God.” 2 Corinthians 1:3-4 (NIV)
    </p>

    <p>
      Take a moment to think about these different experiences and how they have impacted your life:
    </p>

    <p>
      <br>
      <b>Spiritual experiences</b> <br>
      meaningful decisions, times with God, times you felt especially close to God.
    </p>

    <el-form-item>
      <el-input type="textarea" :rows="8"
          :value="experience.spiritual"
          @input="storeExperience('spiritual', arguments[0])"/>
    </el-form-item>

    <p>
      <br>
      <b>Painful experiences</b> <br>
      problems, hurts, trials, etc.
    </p>

    <el-form-item>
      <el-input type="textarea" :rows="8"
          :value="experience.painful"
          @input="storeExperience('painful', arguments[0])"/>
    </el-form-item>

    <p>
      <br>
      <b>Educational experiences</b> <br>
      favorite subjects in school, special training, etc…
    </p>

    <el-form-item>
      <el-input type="textarea" :rows="8"
          :value="experience.educational"
          @input="storeExperience('educational', arguments[0])"/>
    </el-form-item>

    <p>
      <br>
      <b>Ministry experience</b> <br>
      how you've served in the past.
    </p>

    <el-form-item>
      <el-input type="textarea" :rows="8"
          :value="experience.ministry"
          @input="storeExperience('ministry', arguments[0])"/>
    </el-form-item>

    <p>&nbsp;</p>

    <ui-form-actions>
      <el-button @click="goBack">Back</el-button>
      <el-button class="big" type="warning" @click="goForward">Finish</el-button>
    </ui-form-actions>
  </el-form>
</template>

<script>
  /* eslint-disable max-len */

  import step from '../mixins/step';

  export default {
    mixins: [step],
    name: 'Experience',
    methods: {
      goBack() {
        this.$router.back();
      },
      goForward() {
        this.$router.push({ path: '/results' });
      },
      storeExperience(key, value) {
        this.$store.commit('setExperience', { key, value });
      },
    },
    computed: {
      experience() {
        return this.$store.state.experience;
      },
    },
  };
</script>

<style lang="scss">
  .el-button.big {
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Experience.vue